import { serviceStorage } from '../utils/storage/service-storage';
import { useDispatch } from 'react-redux';
import requests from '../redux/reducer/requests';
import { useRequestsHandlerData } from './useRequestsHandlerData';
import { setServiceData } from '../redux/reducer/service';

export default function useServiceData() {
  const dispatch = useDispatch();

  const save = (key, value) => {
    const currentData = serviceStorage.get(key);

    if (JSON.stringify(currentData) !== JSON.stringify(value)) {
      serviceStorage.set(key, value);
      dispatch(setServiceData(serviceStorage.storage));
      return dispatch(requests.thunks.saveServiceData(serviceStorage.storage));
    }
  };

  const get = (key) => serviceStorage.get(key);

  const saveAll = (data, ignoreApi = false) => {
    serviceStorage.setAll(data);
    dispatch(setServiceData(serviceStorage.storage));
    if (!ignoreApi) return dispatch(requests.thunks.saveServiceData(serviceStorage.storage));
  };

  const load = () => dispatch(requests.thunks.getServiceData());

  const remove = (key) => {
    serviceStorage.remove(key);
    dispatch(setServiceData(serviceStorage.storage));
    return dispatch(requests.thunks.saveServiceData(serviceStorage.storage));
  };

  useRequestsHandlerData([
    {
      address: `requestsUserServiceDataGet`,
      fulfilled: ({ service_data }) => {
        saveAll(service_data, true);
        dispatch(setServiceData(service_data));
      },
    },
  ]);

  return {
    save,
    get,
    saveAll,
    load,
    remove,
    storage: () => serviceStorage.storage,
  };
}
